<p-fieldset legend="Ata de Recebimento e Julgamento das Propostas Técnicas e Comerciais">
  <div class="row">
    <label class="required col-9 col-form-label">
      Há no procedimento ata de abertura das propostas técnicas e comerciais?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.ExisteAtaAberturaPropostasTecnicasComerciais" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <div class="row">
    <label class="required col-9 col-form-label">
      Há no procedimento ata de recebimento das propostas técnicas e comerciais?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.ExisteAtaRecebimentoPropostasTecnicasComerciais" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <div class="row">
    <label class="required col-9 col-form-label">
      Há no procedimento ata de julgamento das propostas técnicas e comerciais?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.ExisteAtaJulgamentoPropostasTecnicasComerciais" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <p-fieldset legend="Publicações da Ata de Julgamento">
    <div class="row">
      <label class="required col-9 col-form-label">
        Houve publicação da Ata de Julgamento em veículos de comunicação?
      </label>
      <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
        [(ngModel)]="entidade.AtaAberturaJulgamentoHabilitacaoPublicacaoNao" [ngModelOptions]="{standalone: true}">
        <ng-template let-opcao>
          <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
        </ng-template>
      </p-selectButton>
    </div>
    <lib-licitacao-audesp-publicacao *ngIf="entidade.AtaAberturaJulgamentoHabilitacaoPublicacaoNao === 'S'"
      [entidade]="entidade" [campo]="'AtaAberturaJulgamentoHabilitacaoPublicacao'">
    </lib-licitacao-audesp-publicacao>
  </p-fieldset>
</p-fieldset>
<p-fieldset legend="Negociação Final">
  <div class="row">
    <label class="required col-3 col-form-label">
      Há no procedimento proposta comercial?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.ExisteProcedimentoPropostaComercial" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
    <label class="required col-3 col-form-label">
      Foi realizado chamado para negociação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.FoiRealizadoChamadoNegociacao" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
    <label class="required col-3 col-form-label">
      Foram registradas as atas das reuniões de negociação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.ForamRegistradasAtasReunioesNegociacao" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
    <label class="required col-3 col-form-label">
      Houve proposta final?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="entidade.ExistePropostaFinal"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
    <label class="required col-3 col-form-label">
      Há ata de julgamento final?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.ExisteAtaJulgamentoFinal" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>
<p-fieldset legend="Quadro Comparativo de Preços das Propostas">
  <div class="row">
    <label class="required col-3 col-form-label">
      Existe quadro comparativo de preços das propostas?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.ExisteQuadroComparativo" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>
<lib-licitacao-audesp-recurso [entidade]="entidade"></lib-licitacao-audesp-recurso>